import { render, staticRenderFns } from "./TempTerritoryList.vue?vue&type=template&id=07ac9dae&scoped=true&"
import script from "./TempTerritoryList.vue?vue&type=script&lang=js&"
export * from "./TempTerritoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac9dae",
  null
  
)

export default component.exports